import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { KostDataImportDeNewComponent } from './new/new.component';
import { BdPageTitleService } from '@bindoc-projects/util-lib/data';

const routes: Routes = [
  {
    path: 'kost',
    canActivate: [MsalGuard],
    data: {
      pageTitle: BdPageTitleService.title(
        'Struktur- und Leistungsdaten Import',
      ),
    },
    children: [
      {
        path: 'new',
        canActivate: [MsalGuard],
        component: KostDataImportDeNewComponent,
      },
    ],
  },
  {
    path: 'diagnostics',
    loadComponent: () =>
      import('@bindoc-projects/application-support-feature').then(
        (m) => m.DiagnosticsPageComponent,
      ),
  },
  {
    path: '',
    redirectTo: 'kost/new',
    pathMatch: 'full',
  },
  {
    path: 'access-denied',
    loadComponent: () =>
      import('@bindoc-projects/status-lib/ui').then(
        (m) => m.BdUiAccessDeniedComponent,
      ),
  },
  {
    // Target of the MsalGuard's loginFailedRoute (see guardConfig in
    // app-config-handler.ts). Must exist here — otherwise a failed login falls
    // through to the wildcard, which either hides the auth problem behind a 404
    // or (where the wildcard redirects into a guarded route) bounces the app
    // straight back into the failing login (BDA-5866).
    path: 'sys-login-failed',
    loadComponent: () =>
      import('@bindoc-projects/application-support-feature').then(
        (m) => m.BdUiLoginFailedComponent,
      ),
  },
  {
    path: '**',
    redirectTo: 'kost/new',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
